module.exports = {"printLink":"Alle Guardian-Informationen ausdrucken"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/protege-all-info.json
// module id = v/vE
// module chunks = 1